var map = {
	"./dettol-liquid.jpg": "336e",
	"./dettol-spray.jpg": "3e9b",
	"./hexisol.jpg": "3018",
	"./savlon-liquid.jpg": "c1d0",
	"./savlon-spray.jpg": "343e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "87f1";